// @flow
import React from 'react'

// components
import { FieldForm, TextForm } from '../../Components/'

const EquipmentMiniAppContent = {
  types: {
    CarKooperativa: {
      types: {
        CarKooperativa_koopEquipment: {
          fieldNames: {
            'drive4x4': 'Pohon 4x4',
            'automaticTransmission': 'Aut. převodovka',
            'combi': 'Kombi',
            'leatherCloth': 'Kožené čalounění',
            'panoramaRoof': 'Panoramatická střecha',
            'parkingAssistant': 'Parkovací asistent',
            'audioPrice': 'Cena audio do (Kč)',
            'abs': 'ABS',
            'hood': 'Kapotáž motocyklu',
            'fallingProtectionFrame': 'Padací rám motocyklu',
            'luggageBox': 'Zavazadlový box motocyklu',
            'equipment': 'Výbava vozidla',
          },
          valueNames: {
            audioPrice: {
              '30000': '30 000',
              '50000': '50 000',
              '80000': '80 000',
              '120000': '120 000'
            }
          },
          fieldOrder: [
            'drive4x4',
            'automaticTransmission',
            'combi',
            'leatherCloth',
            'panoramaRoof',
            'parkingAssistant',
            'abs',
            'hood',
            'fallingProtectionFrame',
            'luggageBox',
            'audioPrice',
          ],
          'components': {
            'drive4x4': {
              'associated': true,
              'name': 'checkboxAssociationTwoColumns',
              'parent': 'equipment',
              'showLabel': false,
              'notForTextForm': true,
            },
            'automaticTransmission': {
              'associated': true,
              'name': 'checkboxAssociationTwoColumns',
              'parent': 'equipment',
              'showLabel': false,
              'notForTextForm': true,
            },
            'combi': {
              'associated': true,
              'name': 'checkboxAssociationTwoColumns',
              'parent': 'equipment',
              'showLabel': false,
              'notForTextForm': true,
            },
            'leatherCloth': {
              'associated': true,
              'name': 'checkboxAssociationTwoColumns',
              'parent': 'equipment',
              'showLabel': false,
              'notForTextForm': true,
            },
            'panoramaRoof': {
              'associated': true,
              'name': 'checkboxAssociationTwoColumns',
              'parent': 'equipment',
              'showLabel': false,
              'notForTextForm': true,
            },
            'parkingAssistant': {
              'associated': true,
              'name': 'checkboxAssociationTwoColumns',
              'parent': 'equipment',
              'showLabel': false,
              'notForTextForm': true,
            },
            'abs': {
              'associated': true,
              'name': 'checkboxAssociationTwoColumns',
              'parent': 'equipment',
              'showLabel': false,
              'notForTextForm': true,
            },
            'hood': {
              'associated': true,
              'name': 'checkboxAssociationTwoColumns',
              'parent': 'equipment',
              'showLabel': false,
              'notForTextForm': true,
            },
            'fallingProtectionFrame': {
              'associated': true,
              'name': 'checkboxAssociationTwoColumns',
              'parent': 'equipment',
              'showLabel': false,
              'notForTextForm': true,
            },
            'luggageBox': {
              'associated': true,
              'name': 'checkboxAssociationTwoColumns',
              'parent': 'equipment',
              'showLabel': false,
              'notForTextForm': true,
            },
          }
        },
      },
      fieldOrder: [
        'equipment',
        'contractServiceCommitment',
      ],
      fieldNames: {
        equipment: '',
        contractServiceCommitment: 'Souhlas s opravou ve smluvním servisu',
      },
      components: {
        contractServiceCommitment: {
          name: 'radios',
          showLabel: true,
          wrapMode: true,
          values: [
            { 'value': true, 'label': 'Ano' },
            { 'value': false, 'label': 'Ne' }
          ]
        }
      }
    }
  },
  fieldOrder: [
    'CarKooperativa'
  ],
  fieldNames: {
    CarKooperativa: ''
  },
}

// types
import type { ExpandedSpecificationDTO } from '../../Core/Types/Field'
import type { FormValueType } from '../../Core/Types/Values'

type EquipmentMiniAppContentProps = {
  formData: Object,
  inputHelps: Object,
  isBackOffice: boolean,
  prefix: string,
  pushIsPristine: boolean,
  textMode: boolean,
  miniAppData: {
    cicEnabledPush?: boolean,
  }
}

export default class EquipmentMiniApp extends React.Component<EquipmentMiniAppContentProps> {
  static defaultProps = {
    isBackOffice: false,
  }

  shouldComponentUpdate(nextProps: EquipmentMiniAppContentProps) {
    return JSON.stringify([nextProps.miniAppData, nextProps.inputHelps]) !==
      JSON.stringify([this.props.miniAppData, this.props.inputHelps]) ||
      nextProps.pushIsPristine !== this.props.pushIsPristine ||
      nextProps.formData.cicEnabled !== this.props.formData.cicEnabled
  }

  render() {
    const { miniAppData, pushIsPristine, formData, inputHelps, textMode, prefix, isBackOffice } = this.props

    // TODO only temporary
    if (!isBackOffice) {
      return null
    }

    if (textMode) {
      return [
        <div className='col-12 mb-4 p-0' key='discountCheckboxes'>
          <div className='text-center mt-3 mb-1' key='title-wrapper'>
            <span className='h3'>
              {EquipmentMiniAppContent.types.CarKooperativa.types.CarKooperativa_koopEquipment.fieldNames.equipment}
            </span>
          </div>
          <TextForm
            blockClassName=''
            content={EquipmentMiniAppContent}
            contentBlockClassName=''
            data={miniAppData.discounts}
            formData={miniAppData.discounts}
            key='equipmentForm'
            prefix={prefix}
            renderWithoutBlockWrappers
            specification={miniAppData.discountSpecification}
          />
        </div>
      ]
    }

    if (!miniAppData.discounts || !Object.keys(miniAppData.discounts).length || !miniAppData.discountSpecification ||
      !formData.cicEnabled && !miniAppData.cicEnabledPush) {
      return null
    }

    return ([
        <div className='col-12 mt-5 mb-4 p-0' key='discountCheckboxes'>
          <FieldForm
            blockClassName=''
            blockClassNameForR=''
            blockContentClassName=''
            content={EquipmentMiniAppContent}
            data={miniAppData.discounts}
            formData={miniAppData.discounts}
            inputHelps={{ CarKooperativa: inputHelps }}
            key='equipmentFieldForm'
            onChangeValue={this.handleOnChangeValue}
            pushIsPristine={pushIsPristine}
            showBlockTitle={false}
            specification={miniAppData.discountSpecification}
            validationErrors={miniAppData.discountValidationErrors}
          />
        </div>
      ]
    )
  }
}


